export default {
  primaryDark: '#274468',
  primaryDefault: '#5D7B9F',
  primaryLight: '#799DC9',
  primaryLighter: '#9DB6D3',
  primaryLightest: '#CBDCF0',

  secondaryDark: '#494741',
  secondaryDefault: '#A39F96',
  secondaryLight: '#C3BFB5',
  secondaryLighter: '#E0DBCE',
  secondaryLightest: '#E8E2D4',

  tertiaryDark: '#282827',
  tertiaryDefault: '#585856',
  tertiaryLight: '#8B8B88',
  tertiaryLighter: '#B5B5B1',
  tertiaryLightest: '#CFCFCB',

  redDark: '#A82200',
  redDefault: '#DD2C00',
  redLight: '#FF3F0F',
  redLighter: '#FF6666',
  redLightest: '#FFD6CC',

  blueDark: '#0077E5',
  blueDefault: '#1890FF',
  blueLight: '#4CA9FF',
  blueLighter: '#80C2FF',
  blueLightest: '#CCE6FF',

  greenDark: '#20950E',
  greenDefault: '#2BC312',
  greenLight: '#3AEA1F',
  greenLighter: '#63EF4E',
  greenLightest: '#D6FBD0',

  yellowDark: '#B27700',
  yellowDefault: '#FFB31C',
  yellowLight: '#FFC34D',
  yellowLighter: '#FFD480',
  yellowLightest: '#FFEECC',

  inkDark: '#0C0D0D',
  inkDefault: '#252627',
  inkLight: '#3E4041',
  inkLighter: '#575A5B',
  inkLightest: '#707475',

  skyDarkest: '#707475',
  skyDark: '#8A8E8F',
  skyDefault: '#A4A7A8',
  skyLight: '#BEC0C1',
  skyLighter: '#F2F2F3',
  skyLightest: '#FFFFFF',

  font: '#363531',

  bg1: '#FFF7EA',
  bg2: '#CCC5B3',
};
